import React from 'react'

import { DictionaryContext } from './context'
import { useDictionaryData } from './hooks'

const { Provider } = DictionaryContext

export const DictionaryProvider = ({ children }) => {
  const data = useDictionaryData()

  return <Provider value={data}>{children}</Provider>
}
